import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, Checkbox } from 'semantic-ui-react'

/**
 * CheckboxGroupFilter
 *
 * Group of checkboxes filter.
 * Used for Street Turns and Lane Label filters.
 */
export const CheckboxGroupFilter = ({ value, onChange, label, options }) => {
  const handleCheckboxChange =
    (optionKey) =>
    (e, { checked }) => {
      onChange({
        ...value,
        [optionKey]: checked,
      })
    }

  const containerRef = useRef(null)

  useEffect(() => {
    const inputs = containerRef.current.querySelectorAll(
      'input[type="checkbox"]',
    )
    inputs.forEach((input, i) => {
      const testId =
        options[i].testId || `marketplace-filters-${options[i].key}-checkbox`
      input.setAttribute('data-testid', testId)
    })
  }, [options])

  return (
    <Form.Field>
      <label>{label}</label>
      <div
        ref={containerRef}
        style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
      >
        {options.map((option) => (
          <Checkbox
            key={option.key}
            label={option.label}
            checked={Boolean(value?.[option.key])}
            onChange={handleCheckboxChange(option.key)}
          />
        ))}
      </div>
    </Form.Field>
  )
}

CheckboxGroupFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      testId: PropTypes.string,
    }),
  ).isRequired,
}

CheckboxGroupFilter.defaultProps = {
  value: {},
  label: 'Filter',
}
